export const apiUrl =
  process.env.API_URL || "https://wereldwijde-weetjes.herokuapp.com";
export const DEFAULT_MESSAGE_TIMEOUT = 3000;
